import type { Block, MeResponse } from "../../api/types";
import { hasPermission } from "../../auth/permissions";
import { isExecution } from "./createBlockOptions";

// canSubmitCompletion mirrors the server's submit-completion rules (C.3, C.4):
// the permission, a block still in flight, and for Execution a non-top block it
// owns. Whether it completes outright or queues for sign-off is the server's
// call by role, so the caller reads that from the response.
export function canSubmitCompletion(block: Block, me: MeResponse): boolean {
  if (!hasPermission(me, "blocks:submit_completion")) {
    return false;
  }
  if (block.status !== "assigned" && block.status !== "in-progress") {
    return false;
  }
  if (isExecution(me)) {
    return block.level !== "top" && (block.exec_owner?.id === me.user.id || block.assignee?.id === me.user.id);
  }
  return true;
}

// canReopen mirrors the progress route's re-open rule: only Admin/Dynasty may
// move a complete block back to in-progress (C.3).
export function canReopen(block: Block, me: MeResponse): boolean {
  const role = me.membership.role.toLowerCase();
  return (
    block.status === "complete" &&
    hasPermission(me, "blocks:update_progress") &&
    (role === "admin" || role === "dynasty")
  );
}
